import { Injectable } from '@angular/core';
import { ShopPayrollSettingsModel } from './model/shop-payroll-settings.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ShopPayrollSettingsService {

  constructor(private http: HttpClient) { }

  getList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/shop-payroll-group/get', requestData);

  }

  getById(id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/shop-payroll-group/get/' + id, '');

  }
  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post(environment.baseUrl + '/shop-payroll-group/export-list', requestData, { headers, responseType: 'blob' })
      .pipe(
      //catchError(this.handleError)
    );

  }

  /**
  * Updates the shop payroll group
  * @param shopPayrollInfo
  * Calls the update API to insert/update the record
  */
  update(shopPayrollInfo: ShopPayrollSettingsModel): Observable<any> {

    return this.http.post(environment.baseUrl + '/shop-payroll-group/update', shopPayrollInfo);

  }


  /**
 *
 * @param shopPayrollInfo
 * Calls the API to delete the record
 */
  delete(shopPayrollInfo: ShopPayrollSettingsModel): Observable<any> {
    return this.http.post(environment.baseUrl + '/shop-payroll-group/delete/' + shopPayrollInfo.shop_id, shopPayrollInfo);
  }

}
